// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"249":"15dcd060","615":"e224b9ab","980":"62c4bdab"}[chunkId] + ".chunk.css";
};